<template>
  <div class="container-fluid pt-5 mt-5">
    <div class="row">
      <div class="col-sm-4 mb-3">
        <UserNav />
      </div>
      <div class="col-sm-8">
        <div class="card">
          <div
            class="p-2 text-center"
            style="background-color: #F69325 ; color: #fff"
          >
            <h4>My Orders</h4>
          </div>
          <div class="row" v-if="loading">
            <div class="col-sm-12">
              <sweetalert-icon class="text-center" icon="loading" />
            </div>
          </div>
          <div
            class="row m-3 border-custom"
            v-else
            v-for="(order, index) in test"
            :key="index"
          >
            <div class="border-custom"></div>
            <div class="col-sm-2 text-center">
              <span>
                {{
                  new Date(order.createdAt * 1000).toLocaleDateString("en-us", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit"
                  })
                }}
              </span>
            </div>
            <div class="col-sm-4 text-center">
              <b-btn
                v-b-toggle="'pending' + order.createdAt"
                class="form-control btn btn-info"
              >
                Products
              </b-btn>
              <b-collapse
                v-bind:id="'pending' + order.createdAt"
                class="pt-2 xx"
              >
                <ul
                  v-for="(vendor, vendorindex) in numberofvendors(order)"
                  :key="vendorindex"
                >
                  <b-container fluid>
                    <b-table
                      :key="flag"
                      show-empty
                      small
                      stacked="md"
                      :busy="loading"
                      :items="callforproduct(vendor)"
                      :fields="fields"
                    >
                      <template v-slot:cell(productname)="data">
                        {{ data.item.name }}
                      </template>

                      <template v-slot:cell(price)="data">
                        ₹ {{ data.item.price }}
                      </template>

                      <template v-slot:cell(Qty)="data">
                        {{ data.item.qty }}
                      </template>

                      <template v-slot:cell(status)="data">
                        <b-badge variant="danger" v-if="data.item.status == 0"
                          >Pending Orders</b-badge
                        >
                        <b-badge
                          variant="info"
                          v-else-if="data.item.status == 1"
                          >Currently Packing</b-badge
                        >
                        <b-badge
                          variant="warning"
                          v-else-if="data.item.status == 2"
                          >Out for Delivery</b-badge
                        >
                        <b-badge
                          variant="success"
                          v-else-if="data.item.status == 3"
                          >Delivered</b-badge
                        >
                      </template>
                    </b-table>
                  </b-container>
                </ul>
              </b-collapse>
            </div>
            <div class="col-sm-2 text-center">
              <span
                >₹
                {{
                  (
                    order.orderAmount +
                    order.delveryCharges -
                    order.discountprice
                  ).toFixed(2)
                }}
              </span>
            </div>
            <div class="col-sm-2 text-center">
              <span>{{ order.payment.type }}</span>
            </div>
            <div class="col-sm-2 text-center">
              <b-btn variant="success" size="sm" @click="generatePDF(order)"
                >Download Invoice</b-btn
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserNav from "@/components/UserNav.vue";
import { dbFs, db } from "@/modules/database";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  data: () => {
    return {
      flag: [],
      loading: false,
      orders: [],
      test: [],
      products: [],
      buckets: [],
      fields: [
        {
          key: "productname",
          label: "Product Name"
        },
        {
          key: "Qty",
          label: "Quantity"
        },
        {
          key: "price",
          label: "Price"
        },
        {
          key: "status",
          label: "Status"
        }
      ]
    };
  },
  components: {
    UserNav
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  mounted() {
    this.setupFirebaseReading();
  },
  methods: {
    setupFirebaseReading: function() {
      this.loading = true;
      this.$bind(
        "orders",
        dbFs
          .collection("order")
          .where("customerId", "==", this.user.uid)
          .where("orderStatus", "==", true)
      )
        .then(() => {
          this.fetchvendordetails();
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        })
        .finally(() => {
          this.getProductsData();
          this.loading = false;
        });
    },
    fetchvendordetails() {
      this.orders.forEach(ele => {
        dbFs
          .collection("order")
          .doc(ele.id)
          .collection("vendor")
          .get()
          .then(res => {
            var i = 0;
            res.forEach(doc => {
              i++;
              let data = doc.data();
              ele["vendordetails" + i] = data;
            });
            this.test.push(ele);
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    getProductsData() {
      this.loading = true;
      this.$bind("products", dbFs.collection("products"))
        .catch(error => {
          console.log(error);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProduct(id, dataType) {
      let productDetails = {
        name: "Not Found",
        unitType: "",
        image: ""
      };
      for (const cusKey of Object.keys(this.products)) {
        const product = this.products[cusKey];
        if (id == product.id) {
          productDetails = product;
        }
      }
      if (dataType == "name") {
        return productDetails.name;
      }
      if (dataType == "unitType") {
        return productDetails.unitType;
      }
      if (dataType == "image") {
        return productDetails.image;
      }
    },
    getLastOrderStatus(status) {
      let lastarr = status.slice(-1)[0];
      return [lastarr];
    },
    gettotalpayment(details) {
      var total = 0;
      for (var x = 12; x < Object.keys(details).length; x++) {
        var v = x - 11;
        details["vendordetails" + v].product.forEach(hes => {
          total += hes.price;
        });
      }
      return total + 50;
    },
    numberofvendors(details) {
      var allvendors = [];
      for (var x = 12; x < Object.keys(details).length; x++) {
        var v = x - 11;
        allvendors.push(details["vendordetails" + v]);
      }
      return allvendors;
    },
    callforproduct(onevendor) {
      var forstatus = onevendor;
      onevendor = onevendor.product;
      var arr = [];
      onevendor.forEach(oneproduct => {
        var buck = {
          vendor: "Noor",
          name: "",
          qty: "",
          price: "",
          status: "",
          gst: 0,
          unitType: ""
        };
        buck.price = oneproduct.price;
        buck.qty = oneproduct.qty;
        buck.status = forstatus.status[0].type;
        this.products.forEach(doc => {
          if (doc.id === oneproduct.productId) {
            buck.name = doc.name;
            buck.unitType = doc.unitType;
            if (doc.gst) {
              buck.gst = doc.gst;
            }
          }
        });
        arr.push(buck);
      });
      return arr;
    },
    generatePDF(specorder) {
      var cc = [];
      for (var y = 12; y < Object.keys(specorder).length; y++) {
        var v = y - 11;
        cc.push(this.callforproduct(specorder["vendordetails" + v]));
      }
      var allprod = [];
      var indx2 = 1;

      cc.forEach(ele => {
        ele.forEach(oneprod => {
          var withoutgst;
          if (oneprod.gst === "nill") {
            oneprod.gst = 0;
          }
          withoutgst = oneprod.price - (oneprod.price * oneprod.gst) / 100;
          var tt = [
            indx2++,
            oneprod.name,
            "₹" + withoutgst,
            oneprod.qty + " " + oneprod.unitType,
            "GST - " + oneprod.gst + "%",
            "₹" + (oneprod.price - withoutgst).toFixed(2),
            "₹" + oneprod.price
          ];
          allprod.push(tt);
        });
      });

      // Generating table body
      var tablebody = [
        [
          "SI. No",
          "Description",
          "Gross Price",
          "Qty",
          "Tax Type",
          "Tax Amount",
          "Total Amount"
        ]
      ];
      allprod.forEach(doc => {
        tablebody.push(doc);
      });
      // Customer Address
      var order_date = new Date(specorder.createdAt * 1000).toLocaleDateString(
        "en-us",
        {
          month: "short",
          day: "numeric",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit"
        }
      );
      var c_name = "";
      var c_addr = "";
      var c_state = "";
      var c_pin = "";
      var order_id = specorder.id;

      var company_name = "";
      var company_address = "";
      var company_state = "";
      var company_pin = "";

      dbFs
        .collection("customer")
        .doc(specorder.customerId)
        .collection("address")
        .doc(specorder.customerAdrId)
        .get()
        .then(res => {
          var data = res.data();
          c_name = data.c_person;
          c_addr = data.firstLine + ", " + data.secondLine;
          c_state = data.state;
          c_pin = data.pincode;
        });

      // Fetch Company details
      var ref = db.ref().child("Company");
      ref.once("value", snap => {
        company_name = snap.val().Name;
        company_address = snap.val().Address;
        company_state = snap.val().State;
        company_pin = snap.val().Pincode;
      });

      // Total Sum
      var total = specorder.orderAmount + specorder.delveryCharges;
      var grandtotal =
        specorder.orderAmount +
        specorder.delveryCharges -
        specorder.discountprice;

      // Calculate COUPON ID
      var coupondiscount = "";
      if (specorder.couponId) {
        dbFs
          .collection("coupon")
          .doc(specorder.couponId)
          .get()
          .then(res => {
            if (res.data().type === 0) {
              coupondiscount = "(" + res.data().value + " %)";
            } else {
              coupondiscount = "(₹ " + res.data().value + ")";
            }
          })
          .catch(error => {
            console.log(error);
          });
      }

      setTimeout(() => {
        var x =
          "data:image/png;base64,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";
        var docDefinition = {
          content: [
            {
              columns: [
                {
                  margin: [-25, -23],
                  image: x,
                  width: 70
                },
                {
                  margin: [-25, -5],
                  width: "35%",
                  text: "Aamcart.com",
                  style: "main"
                },
                {
                  margin: [3, 0],
                  width: "auto",
                  text: [
                    {
                      text: "Tax Invoice/Bill of Supply/Cash Memo",
                      style: "side"
                    },
                    { text: " (Original for Recipient)", style: "sidedown" }
                  ],
                  alignment: "right",
                  lineHeight: 1.2
                }
              ]
            },
            {
              columns: [
                {
                  stack: [
                    // second column consists of paragraphs
                    { text: "Sold By", style: "second1_1" },
                    { text: company_name, style: "second1_2" },
                    {
                      text: company_address,
                      style: "second1_2"
                    },
                    {
                      text: company_state + ", " + company_pin,
                      style: "second1_2"
                    },
                    { text: "INDIA", style: "second1_2" }
                  ]
                },
                {
                  stack: [
                    // second column consists of paragraphs
                    { text: "Billing Address :", style: "second2_1" },
                    { text: c_name, style: "second2_2" },
                    {
                      text: c_addr,
                      style: "second2_2"
                    },
                    { text: "", style: "second2_2" },
                    { text: c_state + ", " + c_pin, style: "second2_2" },
                    { text: "INDIA", style: "second2_2" },
                    { text: "State/UT Code: " + c_state, style: "second2_3" }
                  ]
                }
              ]
            },
            {
              columns: [
                {
                  stack: [
                    // second column consists of paragraphs
                    { text: "PAN No: LAUPS78945Q", style: "third1_1" },
                    {
                      text: "GST Registration Number: 33AALCA0171E",
                      style: "third1_2"
                    }
                  ]
                },
                {
                  stack: [
                    { text: "Order Number: " + order_id, style: "second2_3" },

                    { text: "Order Date:  " + order_date, style: "second2_3" }
                  ]
                }
              ]
            },
            {
              style: "thetable",
              table: {
                headerRows: 1,
                widths: ["auto", 150, "auto", 60, 70, "auto", "auto"],
                body: tablebody
              },
              layout: {
                fillColor: function(rowIndex) {
                  return rowIndex === 0 ? "#CCCCCC" : null;
                }
              }
            },
            {
              style: "downtable",
              table: {
                widths: [386, 110],
                body: [
                  [
                    "Total + Delivery Charges (₹" +
                      specorder.delveryCharges +
                      ")",
                    "₹" + total
                  ],
                  [
                    "Coupon Discount " + coupondiscount,
                    "- ₹" + specorder.discountprice
                  ]
                ]
              }
            },
            {
              style: "totalstyle",
              table: {
                widths: [386, 110],
                body: [["Grand Total", "₹" + grandtotal.toFixed(2)]]
              },
              layout: {
                fillColor: function(rowIndex) {
                  return rowIndex === 0 ? "#CCCCCC" : null;
                }
              }
            },
            {
              text:
                "*ACSSPL-AamCart Seller Services Pvt. Ltd., ARIPL-Amazon Retail India Pvt. Ltd. (only where Amazon Retail India Pvt. Ltd. fulfillment center is co-located)Customers desirous of availing input GST credit are requested to create a Business account and purchase on\n Amazon.in/business from Business eligible offersPlease note that this invoice is not a demand for payment",
              marginTop: 220,
              alignment: "center",
              color: "grey",
              fontSize: 8
            }
          ],
          styles: {
            totalstyle: {
              fontSize: 15
            },
            downtable: {
              marginTop: 12
            },
            main: {
              fontSize: 25,
              bold: true,
              color: "brown"
            },
            side: {
              fontSize: 15,
              color: "black",
              bold: true
            },
            sidedown: {
              color: "black",
              opacity: 0.8,
              fontSize: 12
            },
            second1_1: {
              bold: true,
              fontSize: 13.5,
              marginTop: 50,
              marginBottom: 3
            },
            second1_2: {
              fontSize: 11
            },
            second2_1: {
              alignment: "right",
              bold: true,
              fontSize: 13.5,
              marginTop: 50,
              marginBottom: 3
            },
            second2_2: {
              fontSize: 11,
              alignment: "right"
            },
            second2_3: {
              marginTop: 25,
              alignment: "right",
              bold: true,
              fontSize: 11
            },
            third1_1: {
              bold: true,
              fontSize: 12.2,
              marginTop: 25,
              marginBottom: 3
            },
            third1_2: {
              bold: true,
              fontSize: 12.5
            },
            third1_3: {
              bold: true,
              fontSize: 12.5,
              marginTop: 60
            },
            third2_1: {
              alignment: "right",
              bold: true,
              fontSize: 13.5,
              marginTop: 25,
              marginBottom: 3
            },
            thetable: {
              marginTop: 20
            }
          }
        };
        pdfMake.createPdf(docDefinition).open();
      }, 1500);
    }
  }
};
</script>

<style>
li {
  list-style-type: none;
}
.xx {
  margin-top: 20px;
  margin-left: -150px;
  width: 900px;
}
.border-custom {
  border-bottom: 0.5px solid #ccc;
}
</style>
